<template>
  <div class="bg-card">
    <div class="d-flex justify-content-between">
      <h2>{{ $t('pages.admin.headhunters.assign-companies', 'Assign companies for headhunter') }}</h2>
      <b-button
        v-b-modal.select-companies-modal
        variant="success"
        size="sm"
        class="my-auto"
      >
        {{ $t('pages.admin.headhunters.select-companies', 'Select companies') }}
      </b-button>
    </div>
    <hr class="mt-1">
    <div
      v-if="
        (Array.isArray(selectedCompanies) && selectedCompanies.length === 0)"
    >
      {{ $t('pages.admin.headhunters.no-companies', 'No companies yet...') }}
    </div>
    <div v-else>
      <CompanyLine
        v-for="company in selectedCompanies"
        :key="company.id"
        :company="company"
        :is-selected="true"
      />
    </div>

    <b-modal
      id="select-companies-modal"
      :title="$t('pages.admin.headhunters.select-companies-title', 'Select companies')"
      size="xl"
      header-bg-variant="info"
      button-size="sm"
      scrollable
      body-class="companies-modal-body"
      :ok-title="$t('generic.accept', 'Accept')"
      :cancel-title="$t('generic.cancel', 'Cancel')"
      @ok="selectCompanies"
    >
      <div v-if="companiesList">
        <div class="ml-2">
          <b-form-checkbox
            id="selectAll"
            name="checkbox"
            @change="toggleSelectAll"
          >
            {{ $t('pages.admin.headhunters.select-all') }}
          </b-form-checkbox>
        </div>
        <div
          v-for="company in companiesList"
          :key="company.id"
          class="text-left"
        >
          <CompanyLine
            ref="companyCard"
            :company="company"
            :is-assigned="isCompanyAssigned(company.company.id)"
          />
        </div>
        <div class="select-explain">
          <div>{{ $t('pages.admin.headhunters.select-companies.mark-explain') }}</div>
          <div>{{ $t('pages.admin.headhunters.select-companies.unmark-explain') }}</div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
    import CompanyLine from '@/components/jobs/admin/manageHr/CompanyLine';

    export default {
  components: {
    CompanyLine
  },
  data() {
    return {
      companiesList: null,
      selectedCompanies: [],
      selectedDbCompanies: [],
      userId: null
    }
  },
  computed: {
    companyIds() {
      return this.selectedCompanies.map(company => company.company.id);
    },
    companyDbIds() {
      return this.selectedDbCompanies.map(company => company.company.id);
    }
  },
  mounted() {
    this.getCompanies();
    this.userId = this.$route.params.id;
    if(this.userId != null) {
      this.getSelectedDbCompanies();
    }
  },
  methods: {
    getCompanies() {
      this.axios.get('/admin/companies/active?isPaginated=false')
        .then( response => {
          this.companiesList = response.data.data
        })
        .catch();
    },
    selectCompanies() {
      this.selectedCompanies = [];
      for(let company of this.$refs.companyCard) {
        if(company.checkbox) {
          this.selectedCompanies.push(company.company);
        }
      }
      if(this.userId != null) {
        let result = this.isNewCompaniesSelected();
        if(result.differences > 0) {
          this.$emit('newCompaniesAssigned', true);
        } else {
          this.$emit('newCompaniesAssigned', false);
        }
      }
    },
    getSelectedDbCompanies() {
      this.axios.get('/admin-hr/get-companies/' + this.userId)
        .then( response => {
          this.selectedDbCompanies = response.data;
          this.selectedCompanies = this.selectedDbCompanies
        })
        .catch();
    },
    isCompanyAssigned(companyId) {
      return this.companyIds.includes(companyId);
    },
    isNewCompaniesSelected() {
      let toAdd = this.companyIds.filter(id => this.companyDbIds.indexOf(id) === -1);
      let toRemove = this.companyDbIds.filter(id => this.companyIds.indexOf(id) === -1);
      let count = toAdd.length + toRemove.length;

      return {
        differences: count,
        toAdd: toAdd,
        toRemove: toRemove
      };
    },
    resetCompanies() {
      this.selectedCompanies = this.selectedDbCompanies;
      this.$emit('newCompaniesAssigned', false);
    },
    updateCompanies() {
      let newCompaniesData = {
        difference: this.isNewCompaniesSelected(),
        userId: this.userId
      };
      if(newCompaniesData.difference.differences > 0) {
        this.axios.put('/admin-hr/update-companies', newCompaniesData)
          .then(() => {
            this.getSelectedDbCompanies();
            this.$emit('newCompaniesAssigned', false);
            this.$toastNotification('success', '', this.$t('pages.admin.headhunters.companies-update-success', 'HR companies updated successfully'));
          })
          .catch();
      }
    },
    toggleSelectAll(isSelected) {
      for (let companyCard of this.$refs.companyCard) {
        companyCard.selectCompany(isSelected);
      }
      // for (let company in this.companiesList) {
      //   this.$refs['companyLine' + company.id].selectCompany(isSelected);
      // }
    }
  }
}
</script>

<style lang="scss">
  .companies-modal-body {
    background: #f1f1f1;
  }

  .select-explain {
    font-size: 0.8rem;
    line-height: 0.9rem;
    color: gray;
    margin-top: 1rem;
  }
</style>

